export function useHoverTooltipKeyboardAccess() {
    function revealTooltip(event) {
        if (!event.target.matches(':focus-visible')) {
            return;
        }

        event.target.dispatchEvent(new MouseEvent('mouseenter'));
    }

    function dismissTooltip(event) {
        event.target.dispatchEvent(new MouseEvent('mouseleave'));
    }

    return { revealTooltip, dismissTooltip };
}
